export default "__VITE_ASSET__BDb3JygB__"